import { Button, SvgIconOwnProps, SxProps } from "@mui/material";

interface Props {
  IconSrc: any;
  value: string | null;
  type?: "located" | "phone" | "email" | "link" | "instagram";
}

export const textfieldStyle: SxProps = {
  margin: "0px 20px",
  width: "170px",
  "& label": {
    color: "#715939",
  },
  "& .MuiFilledInput-root": {
    backgroundColor: "transparent",
  },
  "& .MuiFilledInput-root.Mui-focused": {
    backgroundColor: "transparent",
  },
  input: {
    textAlign: "center",
    color: "#715939",
    fontSize: 12,
    fontFamily: "Lato-regular",
    letterSpacing: "1px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#715939",
    },
    "&:hover fieldset": {
      borderColor: "#715939",
    },
  },
};

function getInstagramUsername(url: string) {
  try {
    const match = url.match(/instagram\.com\/([^/?]+)/);
    return match ? match[1] : url;
  } catch {
    return url;
  }
}

const InfoRow = ({ value, type, IconSrc }: Props) => {
  if (!value) return null;

  const anchorTypes: Record<string, string> = {
    phone: "tel:",
    email: "mailto:",
    link: "",
    instagram: "",
    located: `https://www.google.com/maps/search/?api=1&query=`,
  };

  return (
    <div className="contact-row">
      <IconSrc sx={{ color: 'black' }} />
      <a
        href={`${anchorTypes[type ?? ""]}${value}`}
        target="_blank"
        rel="noreferrer"
        style={{ fontFamily: 'Open sans' }}
      >
        {type === "instagram" ? getInstagramUsername(value) : value}
      </a>
    </div>
  );
};

export default InfoRow;
